/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TestEmailForwarding200Response
 */
export interface TestEmailForwarding200Response {
    /**
     * 
     */
    success: boolean;
    /**
     * 
     */
    message: string;
}

/**
 * Check if a given object implements the TestEmailForwarding200Response interface.
 */
export function instanceOfTestEmailForwarding200Response(value: object): value is TestEmailForwarding200Response {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function TestEmailForwarding200ResponseFromJSON(json: any): TestEmailForwarding200Response {
    return TestEmailForwarding200ResponseFromJSONTyped(json, false);
}

export function TestEmailForwarding200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TestEmailForwarding200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'message': json['message'],
    };
}

export function TestEmailForwarding200ResponseToJSON(json: any): TestEmailForwarding200Response {
    return TestEmailForwarding200ResponseToJSONTyped(json, false);
}

export function TestEmailForwarding200ResponseToJSONTyped(value?: TestEmailForwarding200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
    };
}

